module.exports = "<div class=\"filter-tag\">\n  <div class=\"filter-tag__metro-icon c-icon\" ng-if=\"::tagCtrl.isMetroWithColor\">\n    <div class=\"filter-tag__circle\" ng-style=\"::{'background-color': tagCtrl.tag.value.color}\"></div>\n  </div>\n  <div class=\"filter-tag__text\">\n    {$ tagCtrl.tag.title $}\n    <serp-filter-associated-objects\n      filter-param=\"{$ tagCtrl.tag.key $}\"\n      position=\"inline\"\n    />\n  </div>\n  <div class=\"filter-tag__icon c-icon c-icon_cross\" ng-click=\"tagCtrl.removeTag()\">&times;</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/filter-tag/templates/filter-tag.html
// module id = 429
// module chunks = 0